import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'sidebar-item',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoPipe],
  template: `
    <div class="relative px-1"
         (mouseenter)="mouseEnter()"
         (mouseleave)="mouseLeave()">
      <a *ngIf="item.link; else labelTpl"
         [routerLink]="item.link"
          class="{{ itemClassVariant }}">
        <span class="truncate">{{ item.title || (item.translationKey | transloco) }}</span>
      </a>
      <ng-template #labelTpl>
        <div class="{{ itemClassVariant }}">
          <span class="truncate">{{ item.title || (item.translationKey | transloco) }}</span>
          @if(item.children?.length) {
            <img src="images/navigation/chevron.svg" 
                 alt="" 
                 class="w-3 h-3 brightness-0 transition-transform duration-200 ease-in-out"
                 [class.-rotate-90]="!open"
                 [class.rotate-0]="open">
          }
        </div>
      </ng-template>

      <!-- Submenu when item has children -->
      <div *ngIf="item.children?.length && open"
           class="absolute top-0 left-full -ml-px z-50"
           (mouseenter)="mouseEnter()"
           (mouseleave)="mouseLeave()">
        <div class="min-w-56 rounded-md border border-border/60 bg-popover text-popover-foreground ml-1 py-1  shadow-xl">
          <ng-container *ngFor="let child of item.children">
            <sidebar-item [item]="child"></sidebar-item>
          </ng-container>
        </div>
      </div>
    </div>
  `,
  styles: [``],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarItemComponent {
  @Input() item: any;
  open = false;
  timeout: any;
  itemClassVariant = "relative flex cursor-pointer w-full select-none items-center justify-between font-semibold gap-2 text-[14px] rounded-md p-2 outline-none transition-colors hover:bg-muted hover:text-foreground dark:hover:bg-muted/50 focus:bg-muted focus:text-foreground dark:focus:bg-muted/50 focus-visible:bg-muted focus-visible:text-foreground dark:focus-visible:bg-muted/50 data-[highlighted]:bg-muted data-[highlighted]:text-foreground dark:data-[highlighted]:bg-muted/50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed"

  mouseLeave() {
    this.open = false;
  }

  mouseEnter() {
    this.open = true;
  }
}


